/**
 * 最終処分場
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../constants/httpConst'
 import * as types from '../../../mutation-types/driver-types'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/final_disposal_sites`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      limit: 50,
      name: null,
    },
  }
}

 const final_disposal_sites = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
     * 最終処分場取得
     * @param dispatch
     * @param commit
     * @param state
     * @param name
     * @param page
     * @param limit
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit }, { page, limit, name }) {
      dispatch('saveCondition', { limit: limit, name: name })
      const params = { page: page, limit: limit, name: name }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          commit(types.DRIVER_FINALDISPOSALSITE_PAGINATION, { content })
          resolve(data.content)
        })
      })
    },
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    new () {
      const api_path = `${API_PATH}/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params ).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })

    },
    edit ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          commit
          resolve(data.content)
        })
      })
    },
    update ({ commit },{ id, params }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.put(api_path, params ).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    destroy ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
    saveCondition ({ commit, state }, { name,limit }) {
      const _name = (name !== undefined) ? name : state.condition.name
      const _limit = (limit !== undefined) ? limit : state.condition.limit
      const params = {
        limit: _limit,
        name: _name
      }
      commit(types.DRIVER_FINALDISPOSALSITE_CONDITION, { params })
    },
    resetState ({ commit }) {
      commit(types.DRIVER_FINALDISPOSALSITE_RESET_CONDITION)
    },
    resetPagination ({ commit }) {
      commit(types.DRIVER_FINALDISPOSALSITE_RESET_PAGINATION)
    }
  },
  mutations: {
    [types.DRIVER_FINALDISPOSALSITE_RESET_CONDITION] (state) {
      Object.assign(state, getDefaultState())
    },
    [types.DRIVER_FINALDISPOSALSITE_RESET_PAGINATION] (state) {
      Object.assign(state.pagination, getDefaultState().pagination)
    },
    [types.DRIVER_FINALDISPOSALSITE_PAGINATION] (state, { content }) {
      state.pagination = content.pagination
    },
    [types.DRIVER_FINALDISPOSALSITE_CONDITION] (state, { params }) {
      state.condition.name = params.name
      state.condition.limit = params.limit
      
    },
  },
 }

 export default final_disposal_sites
